'use strict'

module.exports = {
  NODE_ENV: '"production"',
  ENV_CONFIG: '"prod"',
  PORTAL_API: '"https://api.easyjcx.com"', // Portal-API https://api.easyjcx.com/api/swagger-ui.html
  SU_API: '"https://api.easyjcx.com/supplier/bid"', // 企业端-API https://api.easyjcx.com/supplier/bid/swagger-ui.html
  AI_API: '"https://ai.easyjcx.com"', // ai-api
  PU_API: '"https://puapi.easyjcx.com/college"', // 高校端-API https://puapi.easyjcx.com/swagger-ui.html
  ALI_OSS_API: '"https://api.easyjcx.com/alioss"', // 通用上传-API https://api.easyjcx.com/alioss/swagger-ui.html
  UPLOAD_API: '"https://api.easyjcx.com/alioss/uploadP/mall"',
  JJW_URL: '"https://www.easyjcx.com "',
  HOME_JCX_URL: '"http://www.easyjcx.cn "',
  HOME_JCX_URL5: '"https://www.easyjcx.com/#/about"', // 竞采星
  HOME_PAGE_URL: '"https://www2.easyjcx.com"', // 新版页面首页
  HOME_ABOUT_PAGE_URL: '"http://www.easyjcx.cn/index.php?catid=5"', // 关于我们
  SSO_PAGE_URL: '"https://login.easyjcx.com"', // 统一登录页面(暂时只提供【供应商】注册登录)
  SP_PAGE_URL: '"https://sp.easyjcx.com"', // 【供应商】管理后台页面
  PU_PAGE_URL: '"https://pu.easyjcx.com"', // 【采购商】管理后台(【采购商】注册)
  MALL_PAGE_URL: '"https://mall.easyjcx.com"', // 竞价商场

}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 33